// react
import React, { useState } from "react";
// redux
import { useDispatch } from "react-redux";
import { GenerateProcess } from "redux-process";

import Radio from "../../../components/Inputs/Radio";
// components
import Paginator from "../../../components/Pagination";

// dependencies
import PropTypes from "../../../lib/prop-types";

// style
import css from "../AddFormModal.module.scss";

const SelectEasyAddReview = (props) => {
	const {
		userID,
		employeeID,
		handleSetAddForm,
		addFormData,
		handleSetEasyAddForms,
		reviewData = { id: null, name: null },
		userReviews,
	} = props;

	const [reviews, setReviews] = useState(userReviews);
	const [currentPage, setCurrentPage] = useState(1);

	const dispatch = useDispatch();

	const handleChange = (value, ii) => {
		handleSetAddForm(value, "review");
		const easyAddForms = reviews.reviews[ii].easy_add_forms;
		handleSetEasyAddForms(easyAddForms);
	};

	// setup some configs
	const PAGE_SIZE = 10;

	const loadReviews = async (page) => {
		// limit and skip values
		const limit = PAGE_SIZE;
		const skip = (page - 1) * limit;
		const response = await dispatch(
			GenerateProcess("ReviewsGetEasyAdd", {
				params: {
					limit,
					skip,
				},
				userID,
				subjectID: employeeID,
			})
		);

		const reviewsResult = response.response.data;
		setReviews(reviewsResult);
	};

	const handlePageChange = async (nextPage) => {
		setCurrentPage(nextPage);
		loadReviews(nextPage);
	};

	return (
		<div>
			<div className={css.modalContent}>
				<div className={css.modalDescription}> Which review would you like to add a form to?</div>

				{reviews.reviews ? (
					<div className={css.reviewItems}>
						<ul>
							{reviews.reviews.map((review, ii) => (
								<li key={`${review.name}-${review._id}`} className={css.reviewItem}>
									<div className={css.reviewSelect}>
										<Radio
											value={review._id === addFormData.review.id || reviewData.id !== null}
											isRadioStyle={true}
											name={review.name}
											label={review.name}
											onChange={() =>
												handleChange(
													{
														id: review._id,
														name: review.name,
														cycleID: review.cycle_id,
													},
													ii
												)
											}
										/>
										<div
											className={css.reviewLabel}
											onClick={() =>
												handleChange(
													{
														id: review._id,
														name: review.name,
														cycleID: review.cycle_id,
													},
													ii
												)
											}
										>{`${review.name} (from ${review.cycle_name})`}</div>
									</div>
								</li>
							))}
						</ul>
					</div>
				) : null}

				{reviews.total_count > 10 ? (
					<div className={css.paginatorWrapper}>
						<Paginator
							pageCount={Math.ceil(reviews.total_count / 10)}
							currentPage={currentPage}
							onClick={handlePageChange}
						/>
					</div>
				) : null}
			</div>
		</div>
	);
};

SelectEasyAddReview.propTypes = {
	handleSetAddForm: PropTypes.func.isRequired,
	handleSetEasyAddForms: PropTypes.func.isRequired,
	userID: PropTypes.string.isRequired,
	employeeID: PropTypes.string.isRequired,
	reviewData: PropTypes.object,
	addFormData: PropTypes.object.isRequired,
	userReviews: PropTypes.object.isRequired,
};

export default SelectEasyAddReview;
